import { render, staticRenderFns } from "./FormBlackfriday.vue?vue&type=template&id=006782d8&scoped=true&"
import script from "./FormBlackfriday.vue?vue&type=script&lang=js&"
export * from "./FormBlackfriday.vue?vue&type=script&lang=js&"
import style0 from "./FormBlackfriday.vue?vue&type=style&index=0&id=006782d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006782d8",
  null
  
)

export default component.exports